import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/hooks/onboarding/loaderChecklistByGoalType";
import type { OnboardingV3GoalType } from "./onboardingV3Types";

const I18n = I18nUtil.createScoped(Translations);

export const LOADER_CHECKLIST_BY_GOAL_TYPE: Record<
  OnboardingV3GoalType,
  readonly [string, string, string, string]
> = {
  million: [
    I18n.t("Reading your income & savings"),
    I18n.t("Compounding your investments"),
    I18n.t("Finding people on your path"),
    I18n.t("Pinpointing your $1M year"),
  ],
  retirement: [
    I18n.t("Reading your income & savings"),
    I18n.t("Sizing your number (25× spending)"),
    I18n.t("Compounding to that target"),
    I18n.t("Pinpointing your work-optional year"),
  ],
  home: [
    I18n.t("Reading your income & savings"),
    I18n.t("Sizing your borrowing power"),
    I18n.t("Adding 3 years of saving"),
    I18n.t("Setting your price ceiling"),
  ],
  emergency: [
    I18n.t("Reading your cash & spending"),
    I18n.t("Stress-testing a lost paycheck"),
    I18n.t("Comparing to a safe cushion"),
    I18n.t("Counting your runway"),
  ],
  idlecash: [
    I18n.t("Reading your cash"),
    I18n.t("Setting aside your safety buffer"),
    I18n.t("Spotting what's sitting idle"),
    I18n.t("Pricing the yield you're missing"),
  ],
  debt: [
    I18n.t("Reading what you owe"),
    I18n.t("Ordering balances by cost"),
    I18n.t("Modeling your payoff pace"),
    I18n.t("Finding your debt-free date"),
  ],
};

export const getLoaderChecklistForGoalType = (
  goalType: OnboardingV3GoalType,
): string[] => [...LOADER_CHECKLIST_BY_GOAL_TYPE[goalType]];
